// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-color: #0c0c0c;
    --primary-color: #0d0d0d;
    --secondary-color: #fff;
    --text-color: #fff;
    --text-color-2: #fff;
    --text-color-3: rgb(204, 0, 0);
    --overlay-color: rgb(12 12 12 / 63%);
}

[data-theme="light"] {
    --bg-color: #ffffff;
    --primary-color: #ffffff;
    --secondary-color: #000;
    --text-color: #000;
    --text-color-2: #000;
    --text-color-3: rgb(204, 0, 0);
    --overlay-color: rgb(255 255 255 / 70%);
}

html,
body {
    height: 100%;
}

body {
    margin: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: visible;
    background-color: var(--bg-color);
    color: var(--text-color);
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-top: 60px;
    border-left: 10px solid var(--primary-color);
    border-right: 10px solid var(--primary-color);
}

ul {
    list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: Marcellus;
}

a,
a:hover {
    color: var(--text-color);
}

p {
    word-break: break-word;
    hyphens: auto;
}

.ovhidden {
    overflow: hidden;
}

.text_2,
.text_2:hover {
    color: var(--text-color-2);
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.cursor__dot div {
    z-index: 999999 !important;
}

.cursor__dot div:last-child {
    background-color: var(--text-color-3) !important;
}

.cursor__dot div:first-child {
    filter: invert(1);
    background-color: var(--overlay-color) !important;
}

.color_pr {
    color: var(--primary-color) !important;
}

.color_sec {
    color: var(--secondary-color);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,wBAAwB;IACxB,kCAAkC;IAClC,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;IACjB,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;IAMI,sBAAsB;AAC1B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IAEtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[":root {\n    --bg-color: #0c0c0c;\n    --primary-color: #0d0d0d;\n    --secondary-color: #fff;\n    --text-color: #fff;\n    --text-color-2: #fff;\n    --text-color-3: rgb(204, 0, 0);\n    --overlay-color: rgb(12 12 12 / 63%);\n}\n\n[data-theme=\"light\"] {\n    --bg-color: #ffffff;\n    --primary-color: #ffffff;\n    --secondary-color: #000;\n    --text-color: #000;\n    --text-color-2: #000;\n    --text-color-3: rgb(204, 0, 0);\n    --overlay-color: rgb(255 255 255 / 70%);\n}\n\nhtml,\nbody {\n    height: 100%;\n}\n\nbody {\n    margin: 0;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: visible;\n    background-color: var(--bg-color);\n    color: var(--text-color);\n    font-family: 'Raleway', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding-top: 60px;\n    border-left: 10px solid var(--primary-color);\n    border-right: 10px solid var(--primary-color);\n}\n\nul {\n    list-style: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: Marcellus;\n}\n\na,\na:hover {\n    color: var(--text-color);\n}\n\np {\n    word-break: break-word;\n    -webkit-hyphens: auto;\n    hyphens: auto;\n}\n\n.ovhidden {\n    overflow: hidden;\n}\n\n.text_2,\n.text_2:hover {\n    color: var(--text-color-2);\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.cursor__dot div {\n    z-index: 999999 !important;\n}\n\n.cursor__dot div:last-child {\n    background-color: var(--text-color-3) !important;\n}\n\n.cursor__dot div:first-child {\n    filter: invert(1);\n    background-color: var(--overlay-color) !important;\n}\n\n.color_pr {\n    color: var(--primary-color) !important;\n}\n\n.color_sec {\n    color: var(--secondary-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
